// Кому видны цены на витрине. По умолчанию — всем: так их видят и покупатели,
// и поисковики, а товарные сниппеты без цены не собираются.
// Настройка «Цены видны всем» в админке может их закрыть — тогда цену видят
// только те, кому доступен магазин (см. useShopAccess).
export const usePricesVisible = () => {
  const shopConfig = useShopConfig();
  const shopAccess = useShopAccess();

  return computed(() => shopConfig.value.prices_public !== false || shopAccess.value);
};
